import { TraitsTypeService } from 'Common/services';
import { capitalizeFirstLetter } from 'Common/utils';
export const getErrorMessage = (traitsType) => {
    const currentTraitsType = capitalizeFirstLetter(traitsType);
    const oppositeTraitsType = capitalizeFirstLetter(TraitsTypeService.getOppositeTraits(traitsType));
    return `Variant-level results are not available for ${currentTraitsType} traits for this dataset. Please see ${oppositeTraitsType} traits or switch to another dataset.`;
};
